import { t } from "@/i18n-js/instance";
import {
  FIELD_TYPES,
  NUMERIC_FORMATS,
} from "@circle-react/components/SettingsApp/ProfileFields/constants";
import type { NumberOptions } from "../CustomField/NumberInput";
import { getPlaceholderPreview } from "../CustomField/NumberInput";

const getAffix = (numberOptions: NumberOptions) => {
  const { format, position, text } = numberOptions;
  if (format !== NUMERIC_FORMATS.CUSTOM) {
    return { prefix: "", suffix: "" };
  }

  const prefix = position === "left" ? `${text} ` : "";
  const suffix = position === "right" ? ` ${text}` : "";
  return { prefix, suffix };
};

const NumberPreview = ({
  number_options: numberOptions,
}: {
  number_options: NumberOptions;
}) => {
  const placeholder = getPlaceholderPreview({ numberOptions });
  const percentSign =
    numberOptions.format === NUMERIC_FORMATS.PERCENT ? "%" : "";
  const { prefix, suffix } = getAffix(numberOptions);
  return `${prefix}${placeholder}${percentSign}${suffix}`;
};

interface CheckboxPreviewProps {
  choices: { id: number; value: string }[];
}

const CheckboxPreview = ({ choices }: CheckboxPreviewProps) => (
  <span className="flex flex-col gap-y-2">
    {choices.map(choice => (
      <span key={choice.id}>{choice.value}</span>
    ))}
  </span>
);

export const FieldTypePreviewInformation = {
  [FIELD_TYPES.TEXT]: () => "-",
  [FIELD_TYPES.LINK]: () => t("profile_fields.form.default_link"),
  [FIELD_TYPES.SELECT]: () => t("profile_fields.form.default_select_option"),
  [FIELD_TYPES.NUMBER]: NumberPreview,
  [FIELD_TYPES.CHECKBOX]: CheckboxPreview,
  [FIELD_TYPES.TEXTAREA]: () => "-",
  [FIELD_TYPES.LOCATION]: () => "-",
};
